import { useMutation } from '@tanstack/react-query';
import {
  QuotesQueryKey,
  updateQuotePreviewInfoMutation,
  updateQuoteUserPhotoMutation,
  updateUserDetailsMutation,
  updateQuoteConfigurationsMutation
} from 'Services';
import { useSubscribedMutation } from '@setvi/shared/hooks';
import { useQuoteConfigStore } from 'pages/auto-rfq/store/rfqConfig';

export const useQuoteDetailsMutations = () => {
  const { updateConfiguration } = useQuoteConfigStore();

  const { mutateAsync: updateQuote, isLoading: isPreviewLoading } =
    useSubscribedMutation(updateQuotePreviewInfoMutation(), [
      QuotesQueryKey.PREVIEW_PDF
    ]);

  const { mutateAsync: updatePhoto, isLoading: isImageLoading } = useMutation(
    updateQuoteUserPhotoMutation()
  );

  const { mutateAsync: updateUserDetails, isLoading: isUserUpdateLoading } =
    useMutation(updateUserDetailsMutation());

  const { mutateAsync: updateQuoteConfigurations, isLoading: isConfigLoading } =
    useMutation({
      ...updateQuoteConfigurationsMutation(),
      onSuccess: data => {
        updateConfiguration(data);
      }
    });

  return {
    updateQuote,
    isPreviewLoading,
    updatePhoto,
    isImageLoading,
    updateUserDetails,
    isUserUpdateLoading,
    updateQuoteConfigurations,
    isConfigLoading,
    isLoading: isPreviewLoading || isImageLoading
  };
};
